







import Component from 'vue-class-component';
import BaseComponent from './BaseComponent';

@Component({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },
})
export default class Checkbox extends BaseComponent {
  localValue = false;

  mounted(): void {
    this.localValue = this.$props.value;

    this.$watch(
      () => this.$props.value,
      (newValue: boolean) => {
        this.localValue = newValue;
      }
    );
  }

  emitChange(): void {
    this.$emit('input', this.localValue);
    this.$emit('change', this.localValue);
  }
}
